/**
 * @file Contributor UI — timelineDefaults.
 */

import { FormField } from "../../../../../../interfaces/formInterfaces";

/** Default "Yes" option value for `timelineAvailable` (matches Yes/No dropdown). */
export function resolveTimelineAvailableDefault(fields: FormField[]): string {
  const f = fields.find((x) => x.name === "timelineAvailable");
  if (!f || f.type !== "DROPDOWN") return "yes";
  const opt = f.dropdown?.options?.find(
    (o) =>
      String(o.value || "").toLowerCase() === "yes" ||
      String(o.label || "").toLowerCase() === "yes"
  );
  return opt ? String(opt.value) : "yes";
}
